var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCabinet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10 .992c-5.522 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10m0 2.99a3.308 3.308 0 1 1 0 6.615 3.308 3.308 0 0 1 0-6.615M5.219 16.615a7.34 7.34 0 0 0 4.779 1.762 7.34 7.34 0 0 0 4.78-1.763c.313-.267.493-.659.493-1.07a3.33 3.33 0 0 0-3.346-3.335H8.076a3.336 3.336 0 0 0-3.352 3.334c0 .412.181.804.495 1.072",
  clipRule: "evenodd"
})));
export default SvgCabinet;